import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React, { createContext, Children, useContext } from 'react';
import { jsx } from '@emotion/react';

/** @jsxFrag React.Fragment */

var PPTemplateContext = createContext({
  partMap: {}
});

var addChild = function (map, key, child) {
  if (!map.hasOwnProperty(key)) {
    map[key] = [];
  } else if (!Array.isArray(map[key])) {
    map[key] = [map[key]];
  } // istanbul ignore next


  if (Array.isArray(child)) {
    var _map$key;

    (_map$key = map[key]).push.apply(_map$key, _toConsumableArray(child));
  } else {
    map[key].push(child);
  }

  return map;
};

// istanbul ignore next
var NamePart = function (_ref) {
  var children = _ref.children;
  return jsx(React.Fragment, null, children);
};
var collateChildren = function (children) {
  var partMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var anonymousName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '$anonymous';
  return Children.toArray(children).reduce(function (childMap, child) {
    var childElem = child;

    if (typeof childElem.type === 'function') {
      var displayName = childElem.type.name;

      if (displayName === 'NamePart') {
        var _childElem$props$name;

        return addChild(childMap, (_childElem$props$name = childElem.props.name) !== null && _childElem$props$name !== void 0 ? _childElem$props$name : anonymousName, childElem);
      }
    }

    return addChild(childMap, anonymousName, child);
  }, partMap);
};
var PartProvider = function (_ref2) {
  var parts = _ref2.parts,
      partMap = _ref2.partMap,
      children = _ref2.children,
      anonymousName = _ref2.anonymousName;
  var collatedParts = collateChildren(parts, partMap, anonymousName);
  return jsx(PPTemplateContext.Provider, {
    value: {
      partMap: collatedParts
    },
    "data-ppui": "true"
  }, children);
};
var IncludePart = function (_ref3) {
  var name = _ref3.name;
  var templateContext = useContext(PPTemplateContext);
  var partMap = templateContext.partMap;
  return partMap[name];
};

export { IncludePart, NamePart, PPTemplateContext, PartProvider, collateChildren };
